module.exports = __webpack_public_path__ + "static/media/aggregates-on-sand-tablet.a1d8227f.jpg";